// extracted by mini-css-extract-plugin
export default {"content":"LuckyLettersPage_content__rPrY-","letters":"LuckyLettersPage_letters__zkZxI"};